import { render } from "./EmployeeDataImportModal.vue?vue&type=template&id=b8d15eb4&scoped=true"
import script from "./EmployeeDataImportModal.vue?vue&type=script&lang=js"
export * from "./EmployeeDataImportModal.vue?vue&type=script&lang=js"

import "./EmployeeDataImportModal.vue?vue&type=style&index=0&id=b8d15eb4&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d15eb4"]])

export default __exports__